/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1075
 */

var r = require(/* 633 */"../1774/633")
var o = require(/* 168 */"../1648/168")
module.exports = !!Object.getOwnPropertySymbols && !o(function () {
  var e = Symbol()
  return !String(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && r && r < 41
})
